import { cn } from '@/lib/utils';

interface WhatsAppIconProps {
  className?: string;
}

const WhatsAppIcon = ({ className }: WhatsAppIconProps) => {
  return (
    <svg
      className={cn(className)}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.52 3.48A11.94 11.94 0 0012 .5C5.65 .5 .5 5.65 .5 12c0 2.12.55 4.17 1.6 5.98L.5 23.5l5.68-1.58A11.94 11.94 0 0012 23.5c6.35 0 11.5-5.15 11.5-11.5 0-3.08-1.2-5.95-3.48-7.52zM12 21.5a9.47 9.47 0 01-4.81-1.31l-.34-.2L5 20l.99-1.84-.21-.35A9.47 9.47 0 012.5 12C2.5 6.69 6.69 2.5 12 2.5s9.5 4.19 9.5 9.5S17.31 21.5 12 21.5z" />
      <path d="M17.6 14.9c-.3-.15-1.77-.87-2.05-.97-.28-.1-.48-.15-.68.15s-.78.97-.96 1.17c-.18.2-.36.22-.66.07-.3-.15-1.26-.46-2.4-1.48-.89-.8-1.49-1.78-1.66-2.08-.17-.3-.02-.46.13-.6.14-.14.3-.36.45-.54.15-.18.2-.3.3-.48.1-.18.05-.34-.02-.49-.07-.15-.68-1.64-.93-2.25-.24-.58-.49-.5-.68-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.03 1.01-1.03 2.46 0 1.45 1.05 2.85 1.2 3.05.15.2 2.08 3.3 5.05 4.62 2.97 1.32 3.08 1.11 3.64 1.04.56-.07 1.77-.72 2.02-1.41.25-.69.25-1.28.17-1.4-.08-.13-.28-.2-.58-.35z" />
    </svg>
  );
};

export default WhatsAppIcon;
